var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76953 0L11.9436 4.63131L17.329 6.21885L13.9052 10.6687L14.0596 16.2812L8.76953 14.4L3.47946 16.2812L3.63383 10.6687L0.210023 6.21885L5.59549 4.63131L8.76953 0Z",
    fill: "#FFB833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullStarIcon);
export default __webpack_public_path__ + "static/media/full-star-icon.aba4f5e4a5ddbee56e93c928211a3bc8.svg";
export { ForwardRef as ReactComponent };